import * as tslib_1 from "tslib";
import { EventEmitter } from "@angular/core";
import { BaseComponent } from "../../base/base.component";
import { AppComponent } from "../../app.component";
import { Router } from "@angular/router";
import { SidebarUtils } from "../../../crossconcern/utilities/utils/sidebar.utils";
import { Location } from "@angular/common";
import { DIM_BREAKPOINT_DESKTOP_WIDTH, LANG_CODE_EN, LANG_CODE_FR, LANG_CODE_IT } from "../../../crossconcern/utilities/properties/base.property";
import { logData } from "../../../crossconcern/helpers/generic/generic.helper";
import { AlertUtils } from "../../../crossconcern/utilities/utils/alert.utils";
import { TranslateService } from "@ngx-translate/core";
import { UserManager } from "../../../business/managers/user.manager";
var SidebarComponent = /** @class */ (function (_super) {
    tslib_1.__extends(SidebarComponent, _super);
    function SidebarComponent(appComponent, router, location, sidebarUtils, translate, userManager, alertUtils) {
        var _this = _super.call(this, appComponent, router, alertUtils, location) || this;
        _this.appComponent = appComponent;
        _this.router = router;
        _this.location = location;
        _this.sidebarUtils = sidebarUtils;
        _this.translate = translate;
        _this.userManager = userManager;
        _this.alertUtils = alertUtils;
        _this.sidebarItems = [];
        _this.onItemClick = new EventEmitter();
        _this.onSidebarLoaded = new EventEmitter();
        _this.onSidebarToggle = new EventEmitter();
        return _this;
    }
    SidebarComponent.prototype.ngOnInit = function () {
        this.sidebarItems = this.sidebarUtils.getElements();
        logData(this.sidebarItems);
        this.lastExpandedItem = this.sidebarItems.find(function (item) { return !item.isCollapsed; });
        // this.lastActiveChild = this.lastExpandedItem.children.find((item) => item.isActive);
        this.onSidebarLoaded.emit();
    };
    SidebarComponent.prototype.toggleSidebar = function () {
        this.onSidebarToggle.emit();
    };
    SidebarComponent.prototype.toggleCollapsed = function (item) {
        if (this.lastExpandedItem && item !== this.lastExpandedItem) {
            this.lastExpandedItem.isCollapsed = true;
        }
        item.isCollapsed = !item.isCollapsed;
        this.lastExpandedItem = item;
        if (!(item.children && item.children.length > 0)) {
            this.onClick(item);
        }
    };
    SidebarComponent.prototype.onClick = function (item) {
        this.onItemClick.emit(item);
        if (this.lastActiveChild) {
            this.lastActiveChild.isActive = false;
        }
        item.isActive = true;
        this.lastActiveChild = item;
        if (window.innerWidth <= DIM_BREAKPOINT_DESKTOP_WIDTH) {
            this.toggleSidebar();
        }
    };
    SidebarComponent.prototype.onItemHover = function (item) {
        item.isHover = true;
    };
    SidebarComponent.prototype.onItemOut = function (item) {
        item.isHover = false;
    };
    SidebarComponent.prototype.setLanguage = function (language) {
        this.translate.use(language);
        this.userManager.setCurrentLanguage(language);
    };
    SidebarComponent.prototype.setLanguageEnglish = function () {
        this.setLanguage(LANG_CODE_EN);
    };
    SidebarComponent.prototype.setLanguageItalian = function () {
        this.setLanguage(LANG_CODE_IT);
    };
    SidebarComponent.prototype.setLanguageFrench = function () {
        this.setLanguage(LANG_CODE_FR);
    };
    SidebarComponent.prototype.currentLangItalian = function () {
        var currentLang = this.translate.currentLang;
        if (currentLang === LANG_CODE_IT) {
            return true;
        }
        return false;
    };
    SidebarComponent.prototype.currentLangEnglish = function () {
        var currentLang = this.translate.currentLang;
        if (currentLang === LANG_CODE_EN) {
            return true;
        }
        return false;
    };
    SidebarComponent.prototype.currentLangFrench = function () {
        var currentLang = this.translate.currentLang;
        if (currentLang === LANG_CODE_FR) {
            return true;
        }
        return false;
    };
    return SidebarComponent;
}(BaseComponent));
export { SidebarComponent };
